(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["logoed-products-list"] && !Shopify.designMode) return;
  try {
    

    $(document).on('change', 'li.logo-filter-list input', function () {
      if ($(this).is(':checked')) {
          $('li.logo-filter-list input').prop('checked', false);
          $(this).prop('checked', true);
          var det_selected_filter = $(this).parents('.logo-filter-list').attr('data-label');
          if ($('[data-name="logo-page-list"] .logo-brands-list[data-filter="' + det_selected_filter + '"]').length > 0) {
              $('.no_product').css('display', 'none')
          } else {
              $('.no_product').css('display', 'block')
          }
          $('[data-name="logo-page-list"] .logo-brands-list').each(function () {
              var _ths = $(this);
              if ($(this).attr('data-filter').trim() == det_selected_filter) {
                  _ths.css('display', 'flex');
                  _ths.css('display', 'flex')
              } else {
                  _ths.css('display', 'none')
              }
          })
      } else {
          $('[data-name="logo-page-list"] .logo-brands-list').each(function () {
              var _ths = $(this);
              _ths.css('display', 'flex')
          })
          $('.no_product').css('display', 'none')
      }
  })
  $(document).on('change', '.mobile-filter [name="filter"]', function () {
      var det_selected_filter = $(this).val();
      if ($('[data-name="logo-page-list"] .logo-brands-list[data-filter="' + det_selected_filter + '"]').length > 0) {
          $('.no_product').css('display', 'none')
      } else {
          $('.no_product').css('display', 'block')
      }
      $('[data-name="logo-page-list"] .logo-brands-list').each(function () {
          var _ths = $(this);
          if ($(this).attr('data-filter').trim() == det_selected_filter) {
              _ths.css('display', 'flex');
              _ths.css('display', 'flex')
          } else {
              _ths.css('display', 'none')
          }
      })
  })
  $(document).ready(function () {
      var scrollTop = $(window).scrollTop(),
          elementOffset = $('.logo-brands-page').offset().top,
          distance = (elementOffset - scrollTop);
      if (distance < -100) {
          $('#scroll-down').attr('value', 'scroll up')
          $('span.arrow_botton_scroll svg').css('transform', 'rotate(180deg)')

      } else {
          $('#scroll-down').attr('value', 'scroll down')
          $('span.arrow_botton_scroll svg').css('transform', 'rotate(0deg)')
      }
  })
  $(window).scroll(function () {
      var scrollTop = $(window).scrollTop(),
          elementOffset = $('.logo-brands-page').offset().top,
          distance = (elementOffset - scrollTop);
      if (distance < -100) {
          $('#scroll-down').attr('value', 'scroll up')
          $('span.arrow_botton_scroll svg').css('transform', 'rotate(180deg)')
      } else {
          $('#scroll-down').attr('value', 'scroll down')
          $('span.arrow_botton_scroll svg').css('transform', 'rotate(0deg)')
      }
  })
  $(document).on('click', '[value="scroll down"]', function () {
      $('html, body').animate({
          scrollTop: $(".scoll_bttom").offset().top - 500
      }, 500);
  })
  $(document).on('click', '[value="scroll up"]', function () {
      $('html, body').animate({
          scrollTop: $(".scoll_top").offset().top - 500
      }, 500);
  })
  

  } catch(e) { console.error(e); }
})();
})();
